import * as React from "react";
import {Slot} from "@radix-ui/react-slot";
import {cva, type VariantProps} from "class-variance-authority";

import {cn} from "../lib/utils";

const badgeVariants = cva("inline-flex items-center justify-center rounded-full border px-2.5 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none cursor-default select-none transition-colors overflow-hidden", {
  variants: {
    variant: {
      default: "bg-primary/15 text-primary border-primary/25",
      destructive: "bg-destructive/15 text-destructive border-destructive/25",
      success: "bg-success/15 text-success border-success/25",
      outline: "border border-input bg-transparent text-foreground",
      secondary: "bg-secondary text-secondary-foreground border-secondary",
      ghost: "border-transparent bg-muted text-foreground/60",
    },
    size: {
      sm: "px-2 py-0.5 text-2xs leading-tight",
      default: "px-2.5 py-1 text-xs",
      lg: "px-3 py-1.5 text-sm",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
});

function Badge({className, variant, size, asChild = false, ...props}: React.ComponentProps<"span"> & VariantProps<typeof badgeVariants> & {asChild?: boolean}) {
  const Comp = asChild ? Slot : "span";

  return <Comp data-slot="badge" className={cn(badgeVariants({variant, size}), className)} {...props} />;
}

export {Badge, badgeVariants};
